import { render, staticRenderFns } from "./ProfileRating.vue?vue&type=template&id=b1ca0c7e&scoped=true&"
import script from "./ProfileRating.vue?vue&type=script&lang=js&"
export * from "./ProfileRating.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRating.vue?vue&type=style&index=0&id=b1ca0c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ca0c7e",
  null
  
)

export default component.exports